import { Component,CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';

@Component({
  selector: 'app-offer-details',
  templateUrl:'./offer-details.component.html',
  styleUrls: ['./offer-details.component.scss'],
})
export class OfferDetailsComponent {
//  loader:boolean = false;
//   constructor() { }

//   ngOnInit() {}

}
